import React from "react";
import BaseModel from "../models/BaseModel";
import PageGroup, { fixedPageGroupTags } from "../models/PageGroup";
import PageGroupDialog from "../modelDialogs/PageGroupDialog";
import BaseModelMap from "../models/BaseModelMap";
import TreeViewModel from "../models/TreeviewModel";
import Logger from "../Logger";
import TreeMenuIcon from "../components/NavigationTree2/TreeMenuIcon";
import { itx } from "../translationItx/itx";
import Page from "../models/Page";
import { FunctionHelpers } from "../gpt/functions/FunctionsHelpers";
import { pageTypeInfo, PageTypes } from "../models/PageTypes";

const logger = new Logger();

export default class PageGroupsTreeViewModel extends TreeViewModel {
  constructor(obj: BaseModel) {
    super(obj);
  }

  get typedObj(): BaseModelMap<PageGroup> {
    return this.obj as BaseModelMap<PageGroup>;
  }

  get isSelectable(): boolean {
    return false;
  }

  get isFolder(): boolean {
    return true;
  }

  getTagNeeded(): boolean {
    return false;
  }
  getDisableEdit(): boolean {
    return true;
  }

  get childCollection(): Array<BaseModel> | undefined {
    function initPageGroupNeeded(): boolean {
      let res = false;
      // check if  if no pageGroup in project
      if (state.pageGroups.size == 0) {
        res = true;
      }
      // check if old PageGroups exist
      state.pageGroups.forEach((pg) => {
        for (let tag in fixedPageGroupTags) {
          if (pg.tag == fixedPageGroupTags[tag] && pg.tag != fixedPageGroupTags.buildingPlans) {
            res = true;
          }
        }
      });
      return res;
    }
    if (initPageGroupNeeded()) {
      PageGroup.initPageGroups();
    }

    return this.typedObj.sortBy("name");
  }

  handleAdd() {
    state.dialogManager.openDialog(<PageGroupDialog parent={this.typedObj} />);
  }

  inlineButton_Add() {
    return (
      <TreeMenuIcon
        onClick={(ev: any) => {
          this.handleAddChild(ev);
        }}
        iconName="plus-circle"
        tooltipKey="inlineButton.addLists" // no itx
        objName={this.obj.className + this.obj.fullTag}
        key={this.obj.className + this.obj.fullTag + "add"} // no itx
      />
    );
  }

  buildAddChildMenuItems(): any {
    const items = new Array<{ id: string; image: JSX.Element; label: string; onClick: () => void }>();
    const pages = new Array<PageTypes>();
    for (let pagetype in PageTypes) {
      if (pageTypeInfo(PageTypes[pagetype]).isList) {
        pages.push(PageTypes[pagetype]);
      }
    }
    pages.forEach((p) => {
      let notInPageGroup = true;
      this.typedObj.forEach((pg) => {
        if (pg.pages.asArray()[0]?.documentType?.type === p) {
          notInPageGroup = false;
        }
      });
      if (notInPageGroup) {
        const name = state.translate(`pageDocumentType.${p}`, p);
        items.push({
          id: p,
          image: <i />,
          label: name,
          onClick: () => {
            const tag = state.translate(`pageDocumentType.${p}Tag`, p.substring(0, 2).toUpperCase()); // itx ok
            let newPageGroup = new PageGroup({ tag: tag, name: name }, this.typedObj);
            let newList = new Page({ tag: tag, name: name }, this.typedObj);
            newList.documentType = { type: p, name: name };
            newPageGroup.pages.add(newList);
            this.typedObj.add(newPageGroup);
          },
        });
      }
    });
    return {
      title:
        items.length == 0
          ? itx("pageGroupTreeViewModel.allListsAlreadycreated", "alle Listen schon vorhanden")
          : itx("pageGroupTreeViewModel.add", "Hinzufügen"),
      items,
    };
  }

  handleAddWithEvent(event: any) {
    this.handleAddChild(event);
  }

  handleAddChild(event: any) {
    state.contextMenuManager.show1(event, this.buildAddChildMenuItems(), []);
  }

  getButtonsAsContextMenuItems(): any[] {
    return this.buttonsAsContextMenuItems().map((item) => {
      if (item.id === "btn_plus-circle") {
        return { ...item, menu: this.buildAddChildMenuItems(), onClick: undefined };
      }
      return item;
    });
  }
  ////////////////////////////////////////////////////////////////////////////////////////
  //
  // inline menu buttons
  //
  ////////////////////////////////////////////////////////////////////////////////////////

  getButtons(): JSX.Element[] | undefined {
    // check here if all page types are already created, if yes, show nothing, if not show add button
    let allPageTypesCreated = true;
    const pageTypesInProject = new Array<PageTypes>();
    this.typedObj.forEach((pg) => {
      if (pg.pages.asArray()[0]?.documentType?.type) {
        pageTypesInProject.push(pg.pages.asArray()[0].documentType.type);
      }
    });
    for (let pagetype in PageTypes) {
      if (pageTypeInfo(PageTypes[pagetype]).isList) {
        if (!pageTypesInProject.includes(PageTypes[pagetype])) {
          allPageTypesCreated = false;
        }
      }
    }
    if (!allPageTypesCreated) {
      return [this.inlineButton_Add()];
    }
    return [];
  }

  ////////////////////////////////////////////////////////////////////////////////////////
  //
  // context menu
  //
  ////////////////////////////////////////////////////////////////////////////////////////

  async getDisabledContextMenuItems(): Promise<Array<string>> {
    return ["paste"]; // no itx
  }

  get contextMenuItems(): any {
    var subLabelPaste = undefined;

    try {
      subLabelPaste = state.contextMenuManager.clipboardData.items[0].name;
    } catch (ex) {
      logger.error(ex);
    }

    return {
      title: this.obj?.name,
      items: [
        this.baseContextMenuItems_Paste(subLabelPaste),

        // this.baseContextMenuItems_Add(   state.translate(
        //   "ContextMenuLables.addFloors",
        //   "Neue Etage hinzufügen",
        // )),
      ],
    };
  }
}
